

























































































































































import Search from '@/views/organisms/Search.vue'
import ApiClient from '@/common/api'
import store from '@/store'
import Global from '@/common/global.js'
import BlueButton from '@/views/atoms/BlueButton.vue'
import SelectBox from '@/views/atoms/SelectBox.vue'
import CheckBox from '@/views/atoms/CheckBox.vue'
import PopupCommentAdd from '@/views/template/PopupCommentAdd.vue'
import PopupSelectAdd from '@/views/template/PopupSelectAdd.vue'
import PopupDisplayItem from '@/views/template/PopupDisplayItem.vue'
import PopupFileUpload from '@/views/template/PopupFileUpload.vue'
import StatusBox from '@/views/molecules/StatusBox.vue'
import PopupVehicleInformationComment from '@/views/template/PopupVehicleInformationComment.vue'
import PopupWorkingStyle from '@/views/template/PopupWorkingStyle.vue'
import TextBox from '@/views/atoms/TextBox.vue'
import TextDatePicker from '@/views/molecules/NoStoreTextDatePicker.vue'
import PopupComfirmDelete from '@/views/template/PopupComfirmDelete.vue'
import PopupCutDate from '@/views/template/PopupCutDate.vue'

export default
  name: 'Fc'

  components: {
    Search
    ApiClient
    BlueButton
    SelectBox
    CheckBox
    PopupCommentAdd
    PopupSelectAdd
    PopupDisplayItem
    PopupFileUpload
    StatusBox
    PopupVehicleInformationComment
    PopupWorkingStyle
    TextBox
    TextDatePicker
    PopupComfirmDelete
    PopupCutDate
  }

  data: () ->
    exportList: {},
    statusList: Global.status(),
    showCommentAdd: false,
    showWorkingStyleAdd: false,
    showShippingForm: false,
    showCustomsClearance: false,
    showDisplayItem: false,
    showHsi: false,
    showMsi: false,
    showAcl: false,
    showExportPermit: false,
    showCarryInSlip: false,
    showPicture: false,
    showVehicleInformation: false,
    showVehicleInformationComment: false,
    showMbl: false,
    showHbl: false,
    showDebitNote: false,
    showFreightDetail: false,
    showDraftBl: false,
    showCustomMaterial: false,
    id: '',
    workingStyleList: Global.workingStyle(),
    shippingFormList: Global.shippingForm(),
    customsClearanceList: Global.customsClearance(),
    defaultNum: 0,
    shipComment: '',
    displayItems: store.getters.defaultSetDisplayItems,
    shipCommentId: '',
    voy: '',
    ship_name: '',
    loading_area: '',
    landing_area: '',
    workingStyle: []
    searchParam: {}
    aclSave: true
    mblSave: true
    hblSave: true
    fcLabel: Global.fcLabel()
    sortChange: {}
    showSorts: {}
    level: 0
    showDelete: false
    booking: ''
    shipper_name: ''
    beforeStr: ''
    statusData: {}
    date: null
    showCutDate: false
    complete_flg: ''
    timeStyle: ''
    changeLedgerNumberObj: {}
    pickupDateObj: {}
    pickupTimeObj: {}

  created: () ->
    store.dispatch('initPostParam')
    @sort('departure_date_plan')
    api = new ApiClient()
    data = await api.get('/fc/login/user_level')
    @level = Number(data.level)
    if store.getters.defaultSetDisplayItems
      store.dispatch('setDisplayItems', store.getters.defaultSetDisplayItems)

  methods: {
    getFcList:() ->
      post = false
      api = new ApiClient()
      for index,row of @searchParam
        if typeof(row) == 'boolean' || (row && row != '')
          post = true
          break
      if post
        data = await api.post('/fc/search/list', @searchParam)
      else
        data = await api.get('/fc/list')
      @exportList = data.list

    checkBox: (num) ->
      if num == "0"
        return false
      return true

    clickComment: (id, comment, ship_comment_id, voy, ship_name, loading_area, landing_area, booking, shipper_name, status, key) ->
      @id = id
      @shipComment = comment
      @shipCommentId = ship_comment_id
      @voy = voy
      @ship_name = ship_name
      @loading_area = loading_area
      @landing_area = landing_area
      @booking = booking
      @shipper_name = shipper_name
      @showCommentAdd = true
      @statusData = {
        id: id,
        index: key,
        status: status,
      }

    close_comment_add: (e) ->
      @showCommentAdd = false
    
    clickWorkingStyle: (id, num) ->
      @id = id
      
      if @exportList[num]['working_style']
        @workingStyle = @exportList[num]['working_style']
      else
        @workingStyle = []
      @showWorkingStyleAdd = true

    clickShippingForm: (id, num) ->
      @id = id
      @defaultNum = num
      @showShippingForm = true

    clickCustomsClearance: (id, num) ->
      @id = id
      @defaultNum = num
      @showCustomsClearance = true

    clickDisplayItem: () ->
      @showDisplayItem = true

    clickCustomMaterial: (id, row) ->
      @id = id
      @booking = row.booking
      @shipper_name = row.shipper_name
      @complete_flg = row.custom_materials_complete_flg
      @showCustomMaterial = true

    clickHsi: (id, row) ->
      @id = id
      @booking = row.booking
      @shipper_name = row.shipper_name
      @showHsi = true

    clickMsi: (id, row) ->
      @id = id
      @booking = row.booking
      @shipper_name = row.shipper_name
      @showMsi = true

    clickAcl: (id, row) ->
      @id = id
      @booking = row.booking
      @shipper_name = row.shipper_name
      if @grayOutCustomsClearance(row)
        @aclSave = false
      else
        @aclSave = true
      @showAcl = true

    clickExportPermit: (id, row) ->
      @id = id
      @booking = row.booking
      @shipper_name = row.shipper_name
      @showExportPermit = true

    clickCarryInSlip: (id, row) ->
      @id = id
      @booking= row.booking
      @shipper_name = row.shipper_name
      @showCarryInSlip = true

    clickPicture: (id, row) ->
      @id = id
      @booking = row.booking
      @shipper_name = row.shipper_name
      @showPicture = true

    clickVehicleInformation: (id, row) ->
      @id = id
      @booking = row.booking
      @shipper_name = row.shipper_name
      @showVehicleInformation = true

    clickVehicleInformationComment: (id, row) ->
      @id = id
      @booking = row.booking
      @shipper_name = row.shipper_name
      @showVehicleInformationComment = true

    clickMbl: (id, row) ->
      @id = id
      @booking = row.booking
      @shipper_name = row.shipper_name
      if @grayOutBusiness(row) || @grayOutCustomsClearance(row) || @grayOutWarehouse(row)
        @mblSave = false
      else
        @mblSave = true
      @showMbl = true

    clickHbl: (id, row) ->
      @id = id
      @booking = row.booking
      @shipper_name = row.shipper_name
      if @grayOutCustomsClearance(row) || @grayOutWarehouse(row)
        @hblSave = false
      else
        @hblSave = true
      @showHbl = true

    clickDebitNote: (id, row) ->
      @id = id
      @booking = row.booking
      @shipper_name = row.shipper_name
      @showDebitNote = true

    clickFreightDetail: (id, row) ->
      @id = id
      @booking = row.booking
      @shipper_name = row.shipper_name
      @showFreightDetail = true

    clickDraftBl: (id, row) ->
      @id = id
      @booking = row.booking
      @shipper_name = row.shipper_name
      @showDraftBl = true

    closeWorkingStyle: (e) ->
      @showWorkingStyleAdd = false

    closeShippingForm: (e) ->
      @showShippingForm = false

    closeCustomsClearance: (e) ->
      @showCustomsClearance = false
    
    closeDisplayItem: (e) ->
      @showDisplayItem = false

    closeCustomMaterial: (e) ->
      @showCustomMaterial = false

    closeHsi: (e) ->
      @showHsi = false

    closeMsi: (e) ->
      @showMsi = false

    closeAcl: (e) ->
      @showAcl = false

    closeExportPermit: (e) ->
      @showExportPermit = false

    closeCarryInSlip: (e) ->
      @showCarryInSlip = false

    closePicture: (e) ->
      @showPicture = false

    closeVehicleInformation: (e) ->
      @showVehicleInformation = false

    closeVehicleInformationComment: (e) ->
      @showVehicleInformationComment = false

    closeMbl: (e) ->
      @showMbl = false

    closeHbl: (e) ->
      @showHbl = false

    closeDebitNote: (e) ->
      @showDebitNote = false

    closeFreightDetail: (e) ->
      @showFreightDetail = false

    closeDraftBl: (e) ->
      @showDraftBl = false

    rv_color: (flag) ->
      if flag == '0'
        return false
      return true

    shippingForm: (num) ->
      return @shippingFormList[num].name

    customsClearance: (num) ->
      return @customsClearanceList[num].name
    
    workingStyleSave:() ->
      @closeWorkingStyle()
      @getFcList()

    shippingFormSave:() ->
      @closeShippingForm()
      @getFcList()
    
    customsClearanceSave:() ->
      @closeCustomsClearance()
      @getFcList()

    commentSave: () ->
      @close_comment_add()
      @getFcList()

    click_search: (postParam) ->
      @searchParam = Object.assign(@searchParam, postParam)
      @getFcList()

    statusChange: (e, index, id) ->
      status = e.val
      if status == '10'
        if @exportList[index].freight_detail_flg == '1'
          status = 3
        else if @exportList[index].hbl_flg == '1'
          status = 2
        else if @exportList[index].vehicle_information_flg == '1'
          status = 1
        else
          status = 0
      param =
        id: id
        status: status
      api = new ApiClient()
      data = await api.post('/fc/save', param)
      if data.errors.length == 0
        @getFcList()

    checkId: (id) ->
      @id = id

    pickUpChange: (bool) ->
      if bool
        flag = 1
      else
        flag = 0
      param =
        id: @id
        pick_up_flg: flag
      api = new ApiClient()
      data = await api.post('/fc/save', param)
    
    workingStyletext: (row) ->
      text = ''
      if !row.working_style
        return '未選択'
      for row, index in row.working_style
        i = row.working_style_id - 1
        if index > 0
          text += '・'
        text += @workingStyleList[i].name
      return text
    grayOutBusiness: (row) ->
      if !row.working_style
        return false
      flag = false
      for r, index in row.working_style
        if r.working_style_id == '1'
          return false
        if r.working_style_id == '2'
          flag = true
        if r.working_style_id == '5'
          return false
      if flag
        return true
      return false
    grayOutCustomsClearance: (row) ->
      if !row.working_style
        return false
      flag = false
      for r, index in row.working_style
        if r.working_style_id == '1'
          return false
        if r.working_style_id == '2'
          return false
        if r.working_style_id == '3'
          flag = true
        if r.working_style_id == '4'
          return false
        if r.working_style_id == '5'
          return false
      if flag
        return true
      return false
    grayOutWarehouse: (row) ->
      if !row.working_style
        return false
      flag = false
      for r, index in row.working_style
        if r.working_style_id == '1'
          return false
        if r.working_style_id == '2'
          return false
        if r.working_style_id == '4'
          flag = true
        if r.working_style_id == '5'
          return false
      if flag
        return true
      return false
    changeLedgerNumber: (v) ->
      # storeに値を持たさないように設定していたので、変更した値を逃がしてボタンを押したときに変更させるようにする。(無理やりです。)
      @changeLedgerNumberObj[@exportList[v.index].id] = v.val

    grayOutCfs:(row) ->
      if !row.shipping_form
        return false
      if row.shipping_form == '3'
        return true
      return false
    grayOutLcfs:(row) ->
      if !row.shipping_form
        return false
      if row.shipping_form == '4'
        return true
      return false
    grayOutAir:(row) ->
      if !row.shipping_form
        return false
      if row.shipping_form == '5'
        return true
      return false
    grayOutBulk:(row) ->
      if !row.shipping_form
        return false
      if row.shipping_form == '6'
        return true
      return false
    grayOutUnworked:(row) ->
      if !row.shipping_form
        return false
      if row.shipping_form == '7'
        return true
      return false
    changePickUpDate: (v) ->
      # storeに値を持たさないように設定していたので、変更した値を逃がしてボタンを押したときに変更させるようにする。(無理やりです。)
      @pickupDateObj[@exportList[v.index].id] = v.val
    changePickUpTime: (v) ->
      # storeに値を持たさないように設定していたので、変更した値を逃がしてボタンを押したときに変更させるようにする。(無理やりです。)
      @pickupTimeObj[@exportList[v.index].id] = v.val
    sort: (str) ->
      if @sortChange[str]
        @$set(@sortChange, str, false)
        param = @searchParam
        delete param[@beforeStr + '_asc']
        delete param[@beforeStr + '_desc']
        param[str + '_desc'] = 'desc'
      else
        @$set(@sortChange, str, true)
        param = @searchParam
        delete param[@beforeStr + '_asc']
        delete param[@beforeStr + '_desc']
        param[str + '_asc'] = 'asc'
      @showSort(str);
      @beforeStr = str
      api = new ApiClient()
      data = await api.post('/fc/search/list', param)
      @exportList = data.list
      @searchParam = param
    showSort: (str) ->
      @$set(@showSorts, str, true)
      for row, key in Object.keys(@sortChange)
        if str != row
          @$set(@showSorts, row, false)
    clickDelete: (id) ->
      @id = id
      @showDelete = true
    closeDelete: () ->
      @showDelete = false
    exportDelete: () ->
      @closeDelete()
      param =
      id: @id
      api = new ApiClient()
      data = await api.post('/fc/delete', param)
      @getFcList()
    click_clear: (postParam) ->
      @searchParam = Object.assign(@searchParam, postParam)
      @getFcList()
    popupCutDateNumber: (id, date, time_style) ->
      @id = id
      @date = date
      @timeStyle = time_style
      @showCutDate = true
    closeCutDate: () ->
      @showCutDate = false
    saveCutDate: (v) ->
      api = new ApiClient()
      data = await api.post('/fc/save', v)
      @getFcList()
      @closeCutDate()
    updateLedgerNumber: (id) ->
      if id of @changeLedgerNumberObj
        param =
          id: id
          ledger_number: @changeLedgerNumberObj[id]
        api = new ApiClient()
        data = await api.post('/fc/save', param)
    updatePickupDateTime: (index) ->
      # 三項演算子がサポートされていないため、代わりに条件演算子を使用
      # オブジェクトにキー(id)が設定されていればオブジェクトの値を使用する。設定されていなければ今の値を使用する
      param =
        id: @exportList[index].id
        pick_up_date: if @exportList[index].id of @pickupDateObj then @pickupDateObj[@exportList[index].id] else @exportList[index].pick_up_date
        pick_up_time: if @exportList[index].id of @pickupTimeObj then @pickupTimeObj[@exportList[index].id] else @exportList[index].pick_up_time
      api = new ApiClient()
      data = await api.post('/fc/save', param)
      @getFcList()
  }
